'use strict';

angular.module('membership')
  .service('vendorDetailsViewModel', [
    'Customer', 'MembershipLookup',
    function (Customer, Lookup) {

      var viewModel = function (item, sites) {

        var self = this;

        self.listeners = {};
        self.item = item || {};
        self.sites = sites;
        
        Lookup.vendors().then(function (data) {
          self.vendors = data;
        });

        Lookup.vendorTypes().then(function (data) {
          self.vendorTypes = data;
        });

        Lookup.projectDescriptions().then(function (data) {
          self.projectDescriptions = data;
        });

        self.on = function (action, callBack) {
          self.listeners[action] = callBack;
        };

        self.notify = function (action, params) {
          if (self.listeners[action]) {
            self.listeners[action](params);
          }
        };

        self.save = function () {
          Customer.saveVendor(self.item).then(function () {
            self.notify('save');
          });
        };

        self.delete = function () {
          Customer.deleteVendor(self.item).then(function () {
            self.notify('delete', { Id: self.item.Id });
          });
        };

      };

      return viewModel;

    }
  ]);
